<template>
  <div id="contact">
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">联系我们 </li>
</ul>
</div>
</div>

<div style="margin:0 auto;line-height:30px" class="widu">
<strong>深圳市钻佳珠宝首饰有限公司</strong>
 <div v-html="tips"></div>

</div>


<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                                <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>


  </div>
</template>

<script>

export default {
  name: 'Contact',
  data(){
  return {
  token:localStorage.authorization,
  level:0,
  excel: '' ,
  tips:'',
  url:"https://www.giazh.com/wechat/config/contact"
  }
  },
  methods:{
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
     downloadData: function () {
         
        this.$http.get(this.url,{},{ headers: {},emulateJSON:true}).then((data)=>{
	    console.log('2222',data);
	       this.tips=data.body.conf_content;

	    }).catch(err => {
				console.log(err);
			      }); 

     }
  },
  components:{
  },
  created(){
		 this.downloadData();

  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}

</style>


// WEBPACK FOOTER //
// src/components/Contact.vue